import React from 'react'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import SpeechBubbles from 'src/assets/images/SpeechBubbles.svg'
import AppName from 'src/components/AppName/AppName'
import PromotionBox, {
  CtaDesigns,
} from 'src/components/HomePromotionsStack/PromotionBox/PromotionBox'
import SvgArrowForward from 'src/components/Svgs/SvgArrowForward'
import Trns from 'src/localization/Trns'
import { organizationIntegrationsUrl } from 'src/navigation/urls'
import { useQueryOwnUser } from 'src/queries/users.queries'
import { css } from 'styled-components'

interface IntegrationsVisibilityPromotionBoxProps {
  ctaDesign: CtaDesigns
  dismissPromo: () => void
}

const IntegrationsVisibilityPromotionBox: React.FC<
  IntegrationsVisibilityPromotionBoxProps
> = (props): React.ReactElement => {
  const { analytics } = useAnalyticsContext()
  const { data: user } = useQueryOwnUser({})

  const handleIntegrationsVisibilityPromoAnalytics = (): void => {
    analytics?.track(
      'home integrations promo - profile integrations - text link press',
      {
        screen: '/home',
        interaction: 'text link press',
        intent: 'open profile integrations page',
      },
    )
  }

  return user?.organizationId === undefined ||
    !user?.hasOrgBookkeeperPermissions ? (
    <></>
  ) : (
    <PromotionBox
      imageSrc={SpeechBubbles}
      id="integrationsPopUpClose"
      title={<Trns source={'We want to hear from you!'} />}
      subtitle={
        <Trns
          source={
            "We're actively building out more integrations with your favorite platforms and would love to hear about the tools you'd like ${appName} to connect with."
          }
          expressions={{
            appName: <AppName />,
          }}
        />
      }
      ctaProps={{
        ctaDesign: props.ctaDesign,
        ctaContent: (
          <>
            <Trns source={'Check out our Integrations Page'} />
            <SvgArrowForward
              css={css`
                transform: scale(calc(14 / 24));
              `}
            />
          </>
        ),
        ctaTo: organizationIntegrationsUrl(user.organizationId),
        ctaAriaLabelSource: 'Check out our Integrations Page',
        onCtaClick: handleIntegrationsVisibilityPromoAnalytics,
      }}
      dismissPromo={props.dismissPromo}
    />
  )
}

export default IntegrationsVisibilityPromotionBox
